<template>
  <v-app>
    <v-data-table
      :page="page"
      :pageCount="numberOfPages"
      :options.sync="options"
      :server-items-length="totalItems"
      :headers="headers"
      :items="items"
      :search="search"
      :loading="loading"
      loading-text="Đang tải dữ liệu... Vui lòng chờ"
      :items-per-page="perPage"
      :footer-props="{
        showFirstLastPage: true
      }"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Tin tức, sự kiện</v-toolbar-title>
          <v-spacer/>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Nhập từ khóa"
            single-line
            hide-details
            clearable
          />
          <v-spacer/>
          <v-btn
            color="primary"
            text
            class="mb-2 mr-2"
            @click="showFilterDialog"
          >
            <v-icon class="mr-2">mdi-filter-variant-plus</v-icon>
            <span v-if="$vuetify.breakpoint.lgAndUp">
              tìm nâng cao
            </span>
          </v-btn>
          <v-btn
            color="success"
            dark
            class="mb-2 mr-2"
            :to="{path: '/admin/news-import'}"
          >
            <v-icon left>mdi-microsoft-excel</v-icon>
            Thêm từ Excel
          </v-btn>
          <v-btn
            color="primary"
            dark
            class="mb-2"
            v-on:click="showDialog()"
          >
            <v-icon left>mdi-plus</v-icon>
            thêm mới
          </v-btn>
          <Form 
            :showDialog="dialog" 
            :item="item" 
            @confirmed="onConfirmed" 
            @cancelled="onCancelled"
          />
          <FormFilter 
            :showDialog="dialogFilter" 
            @confirmed="onFilterConfirmed" 
            @cancelled="onFilterCancelled"
          />
          <v-dialog v-model="dialogDelete" 
            max-width="500px">
            <v-card>
              <v-card-title class="headline">Bạn có chắc bạn muốn xóa mục này?</v-card-title>
              <v-card-actions>
                <v-spacer/>
                <v-btn color="primary darken-1" text @click="closeDelete">Hủy bỏ</v-btn>
                <v-btn color="pink darken-1" text @click="deleteItemConfirm">Đồng ý</v-btn>
                <v-spacer/>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
        <v-tabs right>
          <v-tab @click="getItemsDeleted(0)">Khả dụng</v-tab>
          <v-tab @click="getItemsDeleted(1)">
            <v-icon left>mdi-delete-variant</v-icon>
            Đã xóa
          </v-tab>
        </v-tabs>
        <v-divider/>
      </template>
      <template v-slot:[`item.id`]="{ index }">
        {{ (perPage * (page-1)) +  (index+1) }}
      </template>
      <template v-slot:item.anh_dai_dien="{ item }">
        <v-img
          v-if="item.anh_dai_dien"
          :src="`${apiBaseUrl}/uploads/${item.anh_dai_dien}`"
          class="ma-2"
          width="120"
        >
        </v-img>
        <v-img
          v-else
          src="@/assets/NoImage.jpg"
          class="ma-2"
          width="120"
        >
        </v-img>
      </template>
      <template v-slot:item.trang_thai="{ item }">
        <span v-if="item.trang_thai==0" class="red--text">Bí mật</span>
        <span v-else class="green--text">Công khai</span>
      </template>
      <template v-slot:item.muc_do="{ item }">
        <span v-if="item.muc_do=='WARNING'" class="warning--text">Cảnh báo</span>
        <span v-if="item.muc_do=='DANGER'" class="red--text">Khẩn cấp</span>
      </template>
      <template v-slot:item.actions="{ item }">
        <div style="white-space: nowrap;">
          <template v-if="deleted">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  color="pink"
                  @click="restoreItem(item)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>
                    mdi-backup-restore
                  </v-icon>
                </v-btn>
              </template>
              <span>Khôi phục</span>
            </v-tooltip>
          </template>
          <template v-else>
            <v-btn
              icon
              color="primary"
              @click="editItem(item)"
            >
              <v-icon>
                mdi-pencil
              </v-icon>
            </v-btn>
            <v-btn
              icon
              color="pink"
              @click="deleteItem(item)"
            >
              <v-icon>
                mdi-delete
              </v-icon>
            </v-btn>
          </template>
        </div>
      </template>
      <template v-slot:no-data>
        <v-btn
          color="primary"
          @click="initialize"
        >
          Tải lại
        </v-btn>
      </template>
    </v-data-table>
  </v-app>
</template>
<script>
  import Form from '@/views/admin/news/Form';
  import FormFilter from '@/views/admin/news/Filter';
  import FileSevice from '@/services/File';
  import { mapActions, mapState } from 'vuex';
  export default {
    components: {
      Form,
      FormFilter
    },
    data: () => ({
      loading: false,
      dialog: false,
      dialogDelete: false,
      dialogFilter: false,
      search: '',
      headers: [
        { text: 'STT', value: 'id' },
        { text: 'Ảnh đại diện', value: 'anh_dai_dien', sortable: false },
        { text: 'Tiêu đề', value: 'tieu_de' },
        { text: 'Loại', value: 'category.dien_giai' },
        { text: 'Mức độ', value: 'muc_do' },
        { text: 'Tình trạng', value: 'trang_thai' },
        { 
          align: 'right', 
          text: 'Thao tác', 
          value: 'actions', 
          sortable: false 
        },
      ],
      items: [],
      page: 1,
      totalItems: 0,
      numberOfPages: 0,
      perPage: 10,
      options: {},
      editedIndex: -1,
      item: {},
      exportTypes: ['xls', 'xlsx'],
      filter: {},
      deleted: 0
    }),
    computed: {
      ...mapState([
        'config'
      ]),
      formTitle () {
        return this.editedIndex === -1 ? 'thêm mới' : 'cập nhật';
      },
      apiBaseUrl() {
        return this.config.beUrl;
      }
    },
    watch: {
      options: {
        handler() {
          this.initialize();
        },
      },
      search(){
        this.initialize();
      }
    },
    methods: {
      ...mapActions([
        'openSnackbar'
      ]),
      initialize () {
        const app = this;
        const { page, itemsPerPage } = app.options;
        let pageNumber = page;
        let request = {
          params: {
            size: itemsPerPage,
            page: pageNumber,
            keyword: app.search,
            from: app.filter.tuNgay,
            to: app.filter.denNgay,
            type: app.filter.loaiTin,
            level: app.filter.mucDo,
            status: app.filter.tinhTrang,
            deleted: app.deleted,
          }
        };
        app.loading = true;
        axios.get("api/v1/news", request)
          .then(response => {
            app.items = response.data.data;
            app.totalItems = response.data.total;
            app.numberOfPages = response.data.to;
            app.page = response.data.current_page;
            app.perPage = response.data.per_page;
            app.loading = false;
          })
          .catch(function (error) {
            app.openSnackbar({ type: 'error' });
          });
      },
      getItemsDeleted(status) {
        this.deleted = status;
        this.initialize();
      },
      showDialog(item=null){
        this.item = item||{};
        this.dialog = true;
      },
      onConfirmed(item) {
        this.dialog = false;
        this.initialize();
      },
      onCancelled () {
        this.dialog = false;
      },
      showFilterDialog(){
        this.dialogFilter = true;
      },
      onFilterConfirmed(filter) {
        this.filter=filter;
        this.initialize();
        this.dialogFilter = false;
      },
      onFilterCancelled () {
        this.dialogFilter = false;
      },
      editItem (item) {
        this.editedIndex = this.items.indexOf(item);
        this.item = Object.assign({}, item);
        this.dialog = true;
      },
      deleteItem (item) {
        this.editedIndex = this.items.indexOf(item);
        this.item = Object.assign({}, item);
        this.dialogDelete = true;
      },
      deleteItemConfirm () {
        const app = this;
        axios.delete(`api/v1/news/${app.item.id}`)
          .then(function (resp) {
            app.items = app.items.filter(val => val.id !== app.item.id);
            app.closeDelete();
            app.openSnackbar({ type: 'success' });
          }).catch(function (error) {
            app.openSnackbar({ type: 'error' });
          });
      },
      close () {
        this.dialog = false;
        this.$nextTick(() => {
          this.item = Object.assign({}, this.item);
          this.editedIndex = -1;
        })
      },
      closeDelete () {
        this.dialogDelete = false;
        this.$nextTick(() => {
          this.item = Object.assign({}, this.item);
          this.editedIndex = -1;
        })
      },
      restoreItem(item){
        const app = this;
          axios.patch(`api/v1/news-restore/${item.id}`)
            .then(function (resp) {
              app.initialize();
              app.openSnackbar({ type: 'success' });
            }).catch(function (error) {
              app.openSnackbar({ type: 'error' });
            });
      },
      exportData(type){
        const app = this;
        app.loading=true;
        let params = {
          namereport: 'thong_tin',
          export_type: type,
          filter: {
            tuNgay: app.filter.tuNgay,
            denNgay: app.filter.denNgay,
            loaiTin: app.filter.loaiTin,
            mucDo: app.filter.mucDo,
            tinhTrang: app.filter.tinhTrang
          }
        };
        axios.post('api/v1/export', params, {responseType: 'arraybuffer'})
          .then(function (response) {
            FileSevice.download(response.data, `thong_tin.${type}`);
            app.loading=false;
            app.openSnackbar({ type: 'success' });
          }).catch(function (error) {
            app.openSnackbar({ type: 'error' });
          });
      }
    }
  }
</script>
